import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { AccountService, PortalSettings } from '../../pages/account/services/account.service';

@Injectable({
  providedIn: 'root',
})
export class PortalSettingsService {
  private PortalSettings: PortalSettings | null = null;
  private portalSettingsAreStale = false;
  private portalSettingsSubject = new BehaviorSubject<PortalSettings | null>(null);
  public portalSettings$ = this.portalSettingsSubject.asObservable();

  constructor(private accountService: AccountService) {}

  public getPortalSettings(): PortalSettings {
    return this.PortalSettings;
  }

  public setPortalSettingsAreStale() {
    this.portalSettingsAreStale = true;
  }

  public async fetchPortalSettings(): Promise<PortalSettings> {
    return await this.fetchAndSetPortalSettings(() => this.accountService.getPortalSettings());
  }

  public fetchAnonPortalSettings(): Promise<PortalSettings> {
    return this.fetchAndSetPortalSettings(() => this.accountService.getAnonPortalSettings());
  }

  private async fetchAndSetPortalSettings(endpoint: () => Promise<PortalSettings>): Promise<PortalSettings> {
    if (this.portalSettingsAreStale || this.PortalSettings === null) {
      this.PortalSettings = await endpoint();
      this.updateSettings(this.PortalSettings);
      this.portalSettingsAreStale = false;
    }
    return this.PortalSettings;
  }

  private updateSettings(newSettings: PortalSettings) {
    this.portalSettingsSubject.next(newSettings);
  }
}
